import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pii-cleanup"
// Removes the user's pending message when PII is detected.
// Attached to the PII warning toast so cleanup happens when the toast appears.
//
// Targets #new_message — the DOM ID given to temporary (unpersisted) messages
// rendered by create.turbo_stream.haml. We take the last match because the
// chatbot view may have earlier #new_message elements for greeting messages.
export default class extends Controller {
  connect() {
    const allNewMessages = document.querySelectorAll('#new_message')
    if (allNewMessages.length > 0) {
      allNewMessages[allNewMessages.length - 1].remove()
    }
  }
}
